import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { memo } from 'react';

import {
  Button,
  buttonVariants,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@/ui';
import { cn } from '@/ui/lib/utils';

import { Props } from './types';

const BUTTON_VARIANTS = { color: 'secondary', variant: 'subtle' } as const;

// The system's main page is one click away; its deeper pages sit behind the chevron so a
// system costs one button's width however many links it has.
const OutlinksSplitButton = ({ logo, name, outlinks = [], url }: Props) => {
  const hasMenu = outlinks.length > 0;

  return (
    <div className="inline-flex gap-px">
      <a
        aria-label={`Open in ${name}`}
        className={buttonVariants({
          ...BUTTON_VARIANTS,
          size: 'md',
          className: cn('px-3 pointer-coarse:h-11', hasMenu && 'rounded-r-none')
        })}
        href={url}
        rel="noreferrer"
        target="_blank">
        {logo}
        {name}
      </a>

      {hasMenu && (
        <DropdownMenu>
          <DropdownMenuTrigger>
            <Button
              {...BUTTON_VARIANTS}
              aria-label={`More ${name} links`}
              className="rounded-l-none pointer-coarse:h-11 pointer-coarse:w-11"
              size="icon-md">
              <FontAwesomeIcon icon={faChevronDown} className="h-3 w-3" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            {outlinks.map((outlink) => (
              <DropdownMenuItem
                href={outlink.url}
                key={`outlink-${outlink.name}-${outlink.url}`}
                rel="noreferrer"
                target="_blank">
                {outlink.name}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  );
};

export default memo(OutlinksSplitButton);
